import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.CREATE_BULK_PAYMENT_START:
      return {
        ...state,
        createBulkPayment: {
          ...state.createBulkPayment,
          loading: true,
          error: null,
        },
      };
    case ActionType.CREATE_BULK_PAYMENT_SUCCESS:
      return {
        ...state,
        createBulkPayment: {
          ...state.createBulkPayment,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.CREATE_BULK_PAYMENT_ERROR:
      return {
        ...state,
        createBulkPayment: {
          ...state.createBulkPayment,
          data: payload,
          error: null,
          loading: false,
        },
      };

    case ActionType.CLEAR_CREATE_BULK_PAYMENT_STORE:
      return {
        ...state,
        createBulkPayment: {
          ...state.createBulkPayment,
          error: null,
          loading: false,
          data: null,
        },
      };

    default:
      return null;
  }
};
